import styled from 'styled-components';

export const Title = styled.div`
  font-weight: bold;
  font-size: 16px;
`;

export const VerticalSpace = styled.div`
  margin-top: 16px;
`;
